package com.vamvisions.main.di

import com.vamvisions.main.contact.di.contactModule
import com.vamvisions.main.core.presentation.appshell.AppShellViewModel
import com.vamvisions.main.portfolio.di.portfolioModule
import org.koin.core.module.Module
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

/** Binds the domain interfaces to their browser implementations and the HTTP client. */
expect val coreDataModule: Module

/**
 * ViewModels are plain factories: the web app hosts them in its own per-route ViewModelStore,
 * because Koin's Compose integration would pull in compose-ui.
 */
val corePresentationModule = module {
    factoryOf(::AppShellViewModel)
}

val sharedModules: List<Module> = listOf(coreDataModule, corePresentationModule, portfolioModule, contactModule)
